module.exports = __webpack_public_path__ + "929970055652d3847e9bf07ec69a64db.svg";